import { render, staticRenderFns } from "./IconSaveOutline.vue?vue&type=template&id=0b7383c4"
import script from "./IconSaveOutline.vue?vue&type=script&lang=js"
export * from "./IconSaveOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports